import React, { useState } from "react";
import { Col, Input, Row, Tooltip } from "reactstrap";
import ButtonLoader from "./ButtonLoader";

function CustomeSearchBar(props) {
	const {
		className,
		onClick,
		exportToExcelBtn,
		btnTitle,
		showBtnLoading,
		disabled,
	} = props;
	const [tooltipOpen, setTooltipOpen] = useState(false);
	return (
		<Row>
			<div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end py-2 searchColumn align-items-center">
				{/*Show buttonwhen exportToExcelBtn prop is passed*/}
				{exportToExcelBtn && (
					<Col className="mt-1">
						<ButtonLoader
							className={className}
							onClick={onClick}
							btnTitle={btnTitle}
							showBtnLoading={showBtnLoading}
							disabled={disabled}
						/>
					</Col>
				)}

				{/*--------- Search Input --------*/}

				<Col md={5} sm={5} lg={3}>
					{props.inputValue ? (
						//when there is input value
						<Input
							id="DisabledAutoHideExample"
							className="form-control searchBar"
							type="text"
							placeholder="Search"
							value={props.inputValue ? props.inputValue : ""}
							onChange={(event) => props.handleSearch(event)}
						/>
					) : (
						<Input
							id="DisabledAutoHideExample"
							className="form-control searchBar"
							type="text"
							placeholder="Search"
							onChange={(event) => props.handleSearch(event)}
						/>
					)}

					{/*--------- ToolTip on Hover ------------*/}
					<Tooltip
						id="tooltip-top"
						placement="top"
						isOpen={tooltipOpen}
						autohide={false}
						target="DisabledAutoHideExample"
						contentStyle={{ backgroundColor: "#118a8c" }}
						toggle={() => setTooltipOpen(!tooltipOpen)}
					>
						{props.tooltip}
					</Tooltip>
				</Col>
			</div>
		</Row>
	);
}

export default CustomeSearchBar;
